import React from 'react';
import TagManager from '@sooro-io/react-gtm-module';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './assets/scss/themes.scss';
import Route from './Routes';

TagManager.initialize({
  gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER,
});

function App() {
  return (
    <React.Fragment>
      <Route />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={3}
      />
    </React.Fragment>
  );
}

export default App;
